__turbopack_context__.v({
  "className": "geist_mono_4d93f594-module__X3BQtq__className",
  "variable": "geist_mono_4d93f594-module__X3BQtq__variable",
});
